import { useTranslation, SUPPORTED_LANGS } from '../i18n/LanguageContext';

const LABELS = {
  en: 'English',
  hi: 'हिन्दी',
  mr: 'मराठी',
};

/**
 * Apple-style premium language switcher.
 * Three text buttons separated by hairline dividers.
 * Active language is filled (dark pill); others are quiet text.
 * Persists selection via LanguageContext (localStorage).
 */
function LanguageSwitcher({ className = '' }) {
  const { lang, setLang } = useTranslation();

  return (
    <div
      className={`inline-flex items-center gap-1 px-1 py-1 rounded-full bg-white border border-[#E2E8F0] shadow-soft text-xs font-semibold ${className}`}
      role="group"
      aria-label="Language"
      data-testid="language-switcher"
    >
      {SUPPORTED_LANGS.map((code, i) => {
        const active = lang === code;
        return (
          <button
            key={code}
            type="button"
            onClick={() => setLang(code)}
            aria-pressed={active}
            data-testid={`lang-${code}`}
            className={[
              'px-2.5 py-1 rounded-full transition-all duration-300',
              active
                ? 'bg-[#0F172A] text-white shadow-soft'
                : 'text-[#64748B] hover:text-[#0F172A]',
            ].join(' ')}
            style={{ fontFamily: code === 'en' ? "'Outfit', sans-serif" : 'inherit' }}
          >
            {LABELS[code]}
          </button>
        );
      })}
    </div>
  );
}

export default LanguageSwitcher;
